import { render } from "./FacebookConfirmDialog.vue?vue&type=template&id=1433f174&scoped=true"
import script from "./FacebookConfirmDialog.vue?vue&type=script&lang=js"
export * from "./FacebookConfirmDialog.vue?vue&type=script&lang=js"

import "./FacebookConfirmDialog.vue?vue&type=style&index=0&id=1433f174&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1433f174"]])

export default __exports__